import { Box, Modal, Typography } from "@mui/material";
import { style } from "./modalBoxStyle";

export default function AddEditModal({ isView, setIsView, open, setOpen, setSelectedItem, title, children }: {
    children: any,
    title: string,
    open: boolean,
    setOpen: (value: boolean) => void,
    setSelectedItem: (value: any) => void,
    setIsView?: any,
    isView?: boolean
}) {

    const handleClose = () => {
        if (isView) {
            setIsView(false)
        }
        setOpen(false);
        setSelectedItem(null)
    };

    return (
        <div>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                <Box sx={{ ...style, }}>
                <Typography variant="h5" component="h5" mb={1} fontWeight={500}>{title} </Typography>
                    {children}
                </Box>
            </Modal>
        </div>
    );
}